import React from 'react'
import MaterialSymbol from '../material-symbol'

const Apps = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="apps" {...props} />
))

Apps.displayName = 'Apps'

export default Apps
